/* AEMI Studio — Collection toolbar (Filter / Sort / Grid toggle) */
(function () {
  'use strict';

  var GRID_STORAGE_KEY = 'aemi_collection_grid_v1';

  function initFilterButton() {
    var btn = document.querySelector('[data-aemi-ctb-filter]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var summary = document.querySelector('.mobile-facets__wrapper summary');
      if (summary) summary.click();
    });
  }

  function initSortDrawer() {
    var sortBtn = document.querySelector('[data-aemi-ctb-sort]');
    var sort = document.querySelector('[data-aemi-sort]');
    if (!sortBtn || !sort) return;

    function open() {
      sort.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function close() {
      sort.hidden = true;
      document.body.style.overflow = '';
    }

    sortBtn.addEventListener('click', open);
    sort.querySelectorAll('[data-aemi-sort-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (!sort.hidden && e.key === 'Escape') close();
    });

    var form = sort.querySelector('[data-aemi-sort-form]');
    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target && e.target.name === 'sort_by') {
          var params = new URLSearchParams(window.location.search);
          params.set('sort_by', e.target.value);
          window.location.search = params.toString();
        }
      });
    }
  }

  function applyGrid(cols) {
    var grid = document.getElementById('product-grid');
    if (grid) {
      grid.classList.remove('aemi-grid-1', 'aemi-grid-2');
      grid.classList.add('aemi-grid-' + cols);
    }
    document.body.classList.remove('aemi-grid-1', 'aemi-grid-2');
    document.body.classList.add('aemi-grid-' + cols);

    document.querySelectorAll('[data-aemi-ctb-grid]').forEach(function (btn) {
      btn.classList.toggle(
        'aemi-ctb__grid-btn--active',
        btn.getAttribute('data-aemi-ctb-grid') === String(cols)
      );
    });
  }

  function initGridToggle() {
    var saved = null;
    try { saved = localStorage.getItem(GRID_STORAGE_KEY); } catch (e) {}
    applyGrid(saved === '1' ? 1 : 2);

    document.querySelectorAll('[data-aemi-ctb-grid]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cols = btn.getAttribute('data-aemi-ctb-grid');
        applyGrid(cols);
        try { localStorage.setItem(GRID_STORAGE_KEY, cols); } catch (e) {}
      });
    });
  }

  function init() {
    initFilterButton();
    initSortDrawer();
    initGridToggle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
